'use client';

import { getText } from '@/utils/text/text';

type OptInButtonProps = {
    handleOptInClick?: () => void;
};

export const OptInButtonClient = ({ handleOptInClick }: OptInButtonProps) => {
    return (
        <button className="btn opt-in-button" onClick={() => handleOptInClick?.()}>
            {getText({ text: 'components.siteWideJackpots.ctaOptIn' })}
        </button>
    );
};
